module.exports = _.isArray;